import Heading from "@vfuk/core-heading";
import Paragraph from "@vfuk/core-paragraph";
import Link from "@vfuk/core-link";
import classes from "./SupportTooltip.module.scss";

export interface SupportTooltipContentProps {
  heading: string;
  text?: string;
}

export const supportIcon = (
  <span className={classes.SupportText}>Need help?</span>
);

export const SupportTooltipContent = ({
  heading,
  text,
}: SupportTooltipContentProps) => {
  return (
    <div className={classes.Support}>
      <Heading size={1} weight={3}>
        {heading}
      </Heading>
      {text && <Paragraph>{text}</Paragraph>}
      <Link
        href="/support"
        text="Learn more"
        size={2}
        showUnderline
        appearance="primary"
        data-testid="link-support"
      />
    </div>
  );
};
